import { assignManagerApi } from '@eastcoal/api/auth/operationMember/assignManager'

import { pick } from '@eastcoal/common/utils/object'

import { FormMode } from '@eastcoal/formily/components/CrudForm/enums/FormMode'
import { CrudModalForm } from '@eastcoal/formily/components/CrudModalForm'
import { CancelButton } from '@eastcoal/formily/components/CrudModalForm/shared/CancelButton'
import { SubmitButton } from '@eastcoal/formily/components/CrudModalForm/shared/SubmitButton'
import { EditableTable } from '@eastcoal/formily/components/EditableTable'
import { FormItem } from '@eastcoal/formily/components/FormItem'
import { PreviewText } from '@eastcoal/formily/components/Preview/Text'

import { DeptUserCascader } from '@eastcoal/shared/@formily/DeptUserCascader'

import { useAssignManagerStore } from '../Store/hooks/useStore'

import { AssignManagerFormProps } from './interface'

const schema: AssignManagerFormProps['schema'] = [
  {
    name: 'members',
    title: '会员列表',
    type: 'array',
    required: true,
    'x-component': EditableTable,
    'x-component-props': {
      bordered: true
    },
    'x-decorator': FormItem,
    items: [
      {
        name: 'memberName',
        title: '会员名称',
        type: 'string',
        'x-pattern': 'readPretty',
        'x-component': PreviewText,
        'x-column-props': {
          width: 160,
          align: 'center'
        }
      },
      {
        name: 'kindNames',
        title: '意向品类',
        type: 'string',
        'x-pattern': 'readPretty',
        'x-component': PreviewText
      }
    ]
  },
  {
    name: '{id: managerId, name: managerName}',
    title: '客户经理',
    type: 'string',
    required: true,
    'x-component': DeptUserCascader,
    'x-decorator': FormItem,
    'x-decorator-props': {
      wrapperWidth: 200
    }
  }
]

export const AssignManagerForm = () => {
  const { tableRef, members, assignFormVisible, toggleAssignFormVisible } =
    useAssignManagerStore(state =>
      pick(state, [
        'tableRef',
        'members',
        'assignFormVisible',
        'toggleAssignFormVisible'
      ])
    )

  const defaultManager =
    members.length === 1
      ? { id: members[0].memberManagerId, name: members[0].memberManagerName }
      : undefined

  const createApi: AssignManagerFormProps['createApi'] = async ({
    members,
    ...restData
  }) => {
    await assignManagerApi({
      ...restData,
      memberIds: members?.map(item => `${item.memberId}`)
    })

    tableRef.current?.reload()
  }

  return (
    <CrudModalForm
      createApi={createApi}
      mode={FormMode.CREATE}
      name='assignManagerForm'
      open={assignFormVisible}
      schema={schema}
      size='large'
      type='drawer'
      values={{ members, manager: defaultManager }}
      actions={[
        <CancelButton key='cancelButton' />,
        <SubmitButton key='submitButton' />
      ]}
      onOpenChange={toggleAssignFormVisible}
    />
  )
}
